export { default } from './product-images';
